import { render, staticRenderFns } from "./leverageSetting.vue?vue&type=template&id=fa7b90aa"
import script from "./leverageSetting.vue?vue&type=script&lang=js"
export * from "./leverageSetting.vue?vue&type=script&lang=js"
import style0 from "./leverageSetting.vue?vue&type=style&index=0&id=fa7b90aa&prod&lang=scss"
import style1 from "./leverageSetting.vue?vue&type=style&index=1&id=fa7b90aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports